/**
 *
 * Customer settings
 *
 */

import React from 'react';
import {
  Grid,
  makeStyles,
  ListItem,
  List,
  ListItemText,
} from '@material-ui/core';
import { FormattedMessage, useIntl } from 'react-intl';
import { ConfigInvoiceDetail, getConfigFromStore } from 'lib/api/customerConfig';

const useStyles = makeStyles((_theme) => ({
  root: {
    width: '100%',
    marginTop: '20px',
  },
  card: {
    width: '500px',
  },
  title: {
    fontSize: '22px',
    fontWeight: 400,
    marginBottom: '24px',
    color: '#4A4A4A',
  },
  subTitle: {
    textTransform: 'uppercase',
    fontSize: '18px',
    fontWeight: 600,
    color: '#4A4A4A',
    margin: '15px 0',
  },
  listContainer: {
    margin: 0,
  },
  listItem: {
    padding: '0 10px',
    marginBottom: '5px'
  },
  listItemText: {
    fontSize: '14px',
    color: '#4a4a4a',
    margin: '5px 0',
    fontFamily: 'Open Sans',
  },
  usernameIcon: {
    backgroundColor: '#00AAE9',
    height: '32px',
    width: '32px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    color: '#fff',
    fontSize:'20px',
    fontWeight: 600,
    textTransform: 'uppercase',
    marginRight: '10px',

  }
}));

export interface MandatorsProps {}

export interface DetailCardContentProps {
  Id: string;
  detailList: ConfigInvoiceDetail[];
  priority: string;
}

export const CustomerSettings: React.FC<MandatorsProps> = () => {
  const classes = useStyles();
  const config = getConfigFromStore();
  const { formatMessage } = useIntl();
  const mustHave: ConfigInvoiceDetail[] = [];
  const niceToHave: ConfigInvoiceDetail[] = [];
  config.InvoiceDetails.map((detail) => {
    if (detail.Priority === 'MustHave') mustHave.push(detail);
    else if (detail.Priority === 'NiceToHave') niceToHave.push(detail);
  });

  const DetailCardContent: React.FC<DetailCardContentProps> = ({ Id, detailList, priority }) => {
    return (
      <div>
        <h3 className={classes.subTitle}><FormattedMessage id={Id} /></h3>
        <List className={classes.listContainer}>
          {detailList.map((detail) => {
            const detailSplit = detail.Name.split('.');
            const detailName =
              detailSplit.length === 1 ? detailSplit[0] : detailSplit[detailSplit.length - 1];
            return detail.Priority === priority ? (
              <div key={detail.Name}>
                <ListItem className={classes.listItem}>
                  <ListItemText
                    primary={
                      <FormattedMessage
                        defaultMessage={detailName}
                        id={`INVOICE_DETAIL.${detailName}`}
                      />
                    }
                    className={classes.listItemText}
                  />
                </ListItem>
              </div>
            ) : null;
          })}
        </List>
      </div>
    );
  };

  return (
    <div>
      <h3 className={classes.title}>{formatMessage({ id: 'SETTINGS_CustomerConfiguration' })}</h3>
      <div className={classes.card} >
          <h3 className={classes.subTitle}>{formatMessage({ id: 'SETTINGS_Settings' })}</h3>
            <ListItem className={classes.listItem}>
              <Grid container justify="space-between">
                <Grid   
                  container
                  direction="row"
                  alignItems="center"
                >
                  <span className={classes.usernameIcon}>{config.DisplayName.charAt(0)}</span>
                  <ListItemText primary={config.DisplayName} className={classes.listItemText} />
                </Grid>
                <Grid item>
                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Grid container justify="space-between">
                <Grid item>
                  <ListItemText primary={<FormattedMessage id="SETTINGS_Autoprocessable" />} className={classes.listItemText} />
                </Grid>
                <Grid item>
                  <ListItemText
                    primary={<FormattedMessage id={`SETTINGS_${config.Autoprocessing}`} />} className={classes.listItemText}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Grid container justify="space-between">
                <Grid item>
                  <ListItemText primary={<FormattedMessage id="SETTINGS_Splitting" />} className={classes.listItemText} />
                </Grid>
                <Grid item>
                  <ListItemText
                    primary={
                      <FormattedMessage
                        id={config.RemoveGuiSplittingArea ? 'SETTINGS_Off' : 'SETTINGS_On'}
                      />
                    }
                    className={classes.listItemText}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem className={classes.listItem}>
              <Grid container justify="space-between">
                <Grid item>
                  <ListItemText primary={<FormattedMessage id="SETTINGS_ReleaseStep" />} className={classes.listItemText} />
                </Grid>
                <Grid item>
                  <ListItemText
                    primary={
                      <FormattedMessage
                        id={config.SkipReleaseStep ? 'SETTINGS_Off' : 'SETTINGS_On'}
                      />
                    }
                    className={classes.listItemText}
                  />
                </Grid>
              </Grid>
            </ListItem>

      </div>
      <DetailCardContent Id="SETTINGS_MustHave" detailList={mustHave} priority="MustHave" />
      <DetailCardContent
        Id="SETTINGS_NiceToHave"
        detailList={niceToHave}
        priority="NiceToHave"
      />  
    </div>
  );
};
